import { FC } from 'react';
import {
  Link as ReactRouterLink,
  LinkProps as ReactRouterLinkProps,
} from 'react-router-dom';
import { genTestID } from '../utils/utils';

type LinkProps = ComponentWithTagProps & ReactRouterLinkProps;

const TaggedLink: FC<LinkProps> = (props) => {
  const { tag, children } = props;
  return (
    <ReactRouterLink {...props} data-testid={genTestID('link', tag)}>
      {children}
    </ReactRouterLink>
  );
};

export default TaggedLink;
